import { Stack } from '@mui/material';
import React, { useState } from 'react';
import ExecuteButton from '../../molecule/execute-button';
import { buttonWidth } from '../../../styles/size';
import { ToParent } from '../../../../libs/domains/services/to-parent';
import ClosePageDaialog from '../../organism/close-page-daialog';

const ReservationNotFoundPage = () => {
  // 「閉じる」警告を開くかどうか
  const [isCloseWarningOpen, setIsCloseWarningOpen] = useState<boolean>(false);

  // 次のページへ移動する
  const moveNextPage = () => {
    ToParent.requestClosing();
    if (window.history.length > 1) {
      setIsCloseWarningOpen(true);
    } else {
      // 閉じる
      window.close();
    }
  };

  return (
    <>
      <Stack justifyContent="center" alignItems="center" spacing={4}>
        <Stack justifyContent="center" alignItems="center">
          <div>この予約情報は登録されておりません。</div>
          <div>新たな予約が必要な場合には改めての申請をお願い致します。</div>
        </Stack>
        <ExecuteButton
          text={'閉じる'}
          onClick={() => moveNextPage()}
          isPrimary={true}
          type="button"
          width={buttonWidth}
        />
      </Stack>
      <ClosePageDaialog isOpen={isCloseWarningOpen} setIsOpen={setIsCloseWarningOpen} />
    </>
  );
};

export default ReservationNotFoundPage;
